export default "dist/0db1520f47986b6c755a66d554bc370d.svg";